const map = {
	"./en/api_key_vault.json": [
		98234,
		[
			234
		]
	],
	"./en/common.json": [
		50822,
		[
			822
		]
	],
	"./en/customer.json": [
		59711,
		[
			711
		]
	],
	"./en/end_of_shift.json": [
		6423,
		[
			423
		]
	],
	"./en/gift_card.json": [
		18820,
		[
			820
		]
	],
	"./en/gift_voucher.json": [
		47200,
		[
			200
		]
	],
	"./en/invoice_arrival.json": [
		75964,
		[
			964
		]
	],
	"./en/navigation.json": [
		66057,
		[
			57
		]
	],
	"./en/onboarding.json": [
		82566,
		[
			566
		]
	],
	"./en/pos.json": [
		60267,
		[
			267
		]
	],
	"./en/product.json": [
		94526,
		[
			526
		]
	],
	"./en/quote.json": [
		10753,
		[
			753
		]
	],
	"./en/sales.json": [
		55829,
		[
			829
		]
	],
	"./en/settings.json": [
		48986,
		[
			986
		]
	],
	"./en/stock_counts.json": [
		44876,
		[
			876
		]
	],
	"./en/stockorder.json": [
		19205,
		[
			205
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3295;
module.exports = webpackAsyncContext;